/** @format */

import React from "react";
import styled from "@emotion/styled";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import homebackgroundImage from "../assets/homeBG.jpg";

const BackgroundWrapper = styled.div`
  min-height: 100vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${homebackgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  margin-bottom: 0; // Add this line
  padding-bottom: 0; // Add this line
`;

const HeroSection = styled.div`
  min-height: 150vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 9rem;
  color: white;

  @media (min-width: 768px) {
    padding: 0 4rem;
  }
`;

const Title = styled.h1`
  font-family: century gothic;
  font-size: 2rem;
  margin: 0;
  span {
    color: #0066cc;
  }

  @media (min-width: 768px) {
    font-size: 6.4rem;
  }
`;

const Subtitle = styled.h2`
  font-family: "century gothic";
  font-size: 2rem;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

const StatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15rem;
  margin-top: 4rem;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 15rem;
    margin-top: 8rem;
  }
`;

const StatItem = styled(motion.div)`
  font-size: 2rem;
  font-family: "century gothic";
  text-align: center;

  @media (min-width: 768px) {
    font-size: 3rem;
    text-align: left;
  }
`;

const AnimatedCounter = ({ target, title }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  React.useEffect(() => {
    if (inView) {
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.5 },
      });
    }
  }, [controls, inView]);

  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    if (inView) {
      const duration = 2000;
      const steps = 60;
      const stepValue = target / steps;
      const stepDuration = duration / steps;

      let currentStep = 0;
      const timer = setInterval(() => {
        if (currentStep < steps) {
          setCount(Math.round(stepValue * currentStep));
          currentStep++;
        } else {
          setCount(target);
          clearInterval(timer);
        }
      }, stepDuration);

      return () => clearInterval(timer);
    }
  }, [inView, target]);

  return (
    <StatItem ref={ref} initial={{ opacity: 0, y: 20 }} animate={controls}>
      {count.toLocaleString()}
      <div style={{ fontSize: "2rem", marginTop: "0.5rem" }}>{title}</div>
    </StatItem>
  );
};

const Home = () => {
  const [titleRef, titleInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <BackgroundWrapper>
      <HeroSection>
        <motion.div
          ref={titleRef}
          initial={{ y: -100, opacity: 10 }}
          animate={titleInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 1, ease: "easeOut" }}>
          <Title>Welcome to</Title>
          <Subtitle>Patel Development Group</Subtitle>
        </motion.div>
        <StatsContainer>
          <AnimatedCounter target={1500} title='Hotels Rooms Developed' />
          <AnimatedCounter target={1000} title='Apartment Units Developed' />
          <AnimatedCounter
            target={50000}
            title='Sq ft of Retail & Healthcare Space Developed'
          />
        </StatsContainer>
        <div style={{ height: "200px" }}></div>
      </HeroSection>
    </BackgroundWrapper>
  );
};

export default Home;
